// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__2CFaH","footer":"ModalCreateQualiphyProcedure_footer__3f8Xo","additionData":"ModalCreateQualiphyProcedure_additionData__1dL-D"};